import { z } from 'zod'

export const roleSchema = z.object({
  display_name: z.string().min(3, 'Campo Nome deve ter no mínimo 3 caracteres'),
  description: z.string().min(3, 'Campo Descrição deve ter no mínimo 3 caracteres'),
  level: z.string().optional().nullable(),
  can_bypass_linked_client_company_restriction: z.boolean().optional(),
  can_bypass_linked_establishment_company_restriction: z.boolean().optional(),
})

export type RoleValidationSchema = z.infer<typeof roleSchema>
